import {
  Box,
  Button,
  Card,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import StudentFeeDetails from '../pages/[admin]/Student/StudentFeeDetails';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { searchForStudent } from '../features/payments/PaymentSlice';
import CloseIcon from '@mui/icons-material/Close';

function PaymentsPage() {
  const dispatch = useDispatch();
  const [studentId, setStudentId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [studentList, setStudentsList] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  async function searchStudent() {
    setLoading(true);
    try {
      const response = await dispatch(searchForStudent(searchValue)).unwrap();
      if (response?.length > 1) {
        setStudentsList(response);
        setStudentId('');
      } else if (response?.length == 1) {
        setStudentId(response?.[0]?.studentId);
        setStudentsList([]);
      } else {
        setStudentId(searchValue);
        setStudentsList([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    return localStorage.removeItem('StudentStatus');
  }, []);
  return (
    <Box className='p-4'>
      {' '}
      <Box className='bg-blue-50 p-4 rounded-lg mb-4'>
        <Typography variant='h6' className='text-blue-700 font-bold'>
          Manage Payments
        </Typography>
        <Typography variant='body1' className='text-gray-600'>
          Search for student and manage student payments details here.
        </Typography>
      </Box>
      <Card className='max-w-5xl px-4 py-10 border'>
        <div className='max-w-5xl '>
          <Typography variant='h6' className='text-[#1976d2] mb-2'>
            {' '}
            Search Student
          </Typography>
          <Card className='p-4 border rounded'>
            <Typography variant='body1' className='mb-2'>
              Enter Student Id and search for the payments history detials.
            </Typography>
            <div className='flex items-end flex-wrap gap-2'>
              <TextField
                value={searchValue}
                id='studentId'
                size='small'
                label='Student Id'
                className=' mr-10 mt-2 w-80'
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      {!!searchValue && (
                        <IconButton
                          onClick={() => {
                            setSearchValue('');
                            setStudentId('');
                            setStudentsList([]);
                          }}
                        >
                          <CloseIcon></CloseIcon>
                        </IconButton>
                      )}
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => setSearchValue(e.target.value)}
              ></TextField>

              <Button
                variant='contained'
                disabled={!searchValue || loading}
                onClick={searchStudent}
              >
                {loading ? 'Searching' : 'Search'}
              </Button>
            </div>
          </Card>
        </div>
        <div className=' mb-4 ml-2 mt-10'>
          {studentList?.length >= 2 && (
            <div>
              <Typography
                color='primary'
                className='mb-2 font-semibold text-lg'
              >
                {' '}
                ⁕ Multiple matches found, please select one among the list to
                manage payments .
              </Typography>
              <TableContainer
                component={Paper}
                variant='outlined'
                sx={{
                  maxHeight: 400,
                  overflow: 'auto',
                }}
              >
                <Table stickyHeader size='small' sx={{ minWidth: 900 }}>
                  <TableHead>
                    <TableRow
                      sx={{ backgroundColor: '#f8fafc', color: '#1976d2' }}
                    >
                      <TableCell className='text-[#1976d2]'>
                        <strong>SNO</strong>
                      </TableCell>
                      <TableCell className='text-[#1976d2]'>
                        <strong>Student Id</strong>
                      </TableCell>
                      <TableCell className='text-[#1976d2]'>
                        <strong>First Name</strong>
                      </TableCell>
                      <TableCell className='text-[#1976d2]'>
                        <strong>Last Name</strong>
                      </TableCell>
                      <TableCell className='text-[#1976d2]'>
                        <strong>Mobile</strong>
                      </TableCell>
                      <TableCell className='text-[#1976d2]'>
                        <strong>Class</strong>
                      </TableCell>
                      <TableCell className='text-[#1976d2]'>
                        <strong>Section</strong>
                      </TableCell>
                      <TableCell className='text-[#1976d2]'>
                        <strong>Actions</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {studentList?.slice(0, 10)?.map((row, index) => (
                      <TableRow
                        className='hover:cursor-pointer'
                        key={row?.id || index}
                        hover
                        sx={{
                          '&:nth-of-type(odd)': {
                            backgroundColor: '#fafafa',
                          },
                        }}
                        onClick={() => {
                          setSearchValue(row?.studentId);
                          setStudentId(row?.studentId);
                          setStudentsList([]);
                        }}
                      >
                        {' '}
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{row?.studentId}</TableCell>
                        <TableCell>{row?.firstName}</TableCell>
                        <TableCell>{row?.lastName}</TableCell>
                        <TableCell>{row?.mobileNumber}</TableCell>
                        <TableCell>{row?.departmentName}</TableCell>
                        <TableCell>{row?.className}</TableCell>
                        <TableCell>
                          {' '}
                          <Button variant='contained'>Open</Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
        </div>
        <StudentFeeDetails StudentId={studentId} />
      </Card>
    </Box>
  );
}
export default PaymentsPage;
